import metadataService from "@/api/metadataService";
import router from '@/router/index';
const state= {
    actors: [],
    loader: false,
    initialData: {},
    metadata: {},
    editId: null,
    newActor: {},

}
const getters = {
    getEditActor: state => state.newActor,
};
const actions = {
    async getActors({ commit,state }) {
        state.loader = true;
        const response = await metadataService.getActors();
        state.loader=false
        commit('get', response.data.result)
    },
    async getInitialData({commit, state}) {
        state.loader=true
        const response = await metadataService.getInitialData();
        state.loader=false
        commit('getInitialData', response.data)
    },
    async addActor({ commit }, actor) {
        const response = await metadataService.addActor(actor);
        if (response.data.status) {
            commit('addActor', response.data.result, { root: true });
        } 
        return response.data;
    },
    async editActor({ commit }, actor) {
        commit('edit', actor);//response.data.result)
    },
    async updateActor({ commit }, actor) {
        const response = await metadataService.updateActor(state.editId, actor);
        commit('updateActor', response.data.result, { root: true });
        return response.data;
    },
    async deleteActor({ commit }, actor) {
        await metadataService.deleteActor(actor.dataItem.id);
        commit('removeActor', actor.dataItem.id, { root: true });
    },

}
const mutations = {
    get(state, actors) {
        state.actors = actors;
        state.filteredDevices = actors;
    },
    getInitialData(state, data) {
        state.initialData = data;
    },
    cancel(state) {
        state.metadata = {}
    },
    edit(state, actor) {
        state.editId = actor.id
        state.newActor = actor
        state.metadata = actor.metaData ? actor.metaData : {}
        router.push({ name: "addMetadata", params: { add: false } });
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}